<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Pontos de Venda</h1>
        <paragrafo
          >Aqui serão cadastrados e listados os pontos de venda.</paragrafo
        >
        <paragrafo
          >O primeiro passo é criar um Ponto de Venda para a loja em
          <negrito>Pessoas > Pontos de Venda</negrito>.
        </paragrafo>
        <imagem :src="image_1" />
        <paragrafo
          >Selecione 'Novo Ponto de Venda' e preencha as informações de cada
          aba, principalmente da aba Equipamentos.</paragrafo
        >
        <paragrafo
          >Após criá-lo, é necessário vincular este Ponto de Venda a um
          equipamento (POS ou QR Code) em
          <negrito>Pessoas > Pontos de Venda > Equipamentos</negrito> (veja a
          explicação deste processo na guia Operações > Equipamentos).
        </paragrafo>
        <li>
          Rede Exclusiva: Selecionar o equipamento que foi cadastrado em
          Operações > Equipamentos e escolher a loja na qual ele ficará
          vinculado
        </li>
        <li>
          Rede Compartilhada: Basta selecionar o equipamento que foi cadastrado
          em Operações > Equipamentos e ele estará automaticamente vinculado a
          regional da loja.
        </li>
        <paragrafo>Veja abaixo as duas opções de configuração:</paragrafo>
        <paragrafo>
          <imagem :src="image_2" />
          <imagem :src="image_3"
        /></paragrafo>
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "PontosVenda",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem.vue"),
    negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_1: "/imagensAdmin/Pessoas/pessoas1.png",
      image_2: "/imagensAdmin/Pessoas/pessoas11.png",
      image_3: "/imagensAdmin/Pessoas/pessoas12.png",
    };
  },
};
</script>
